import { axios, BaseApiUrl,BaseUrl} from '../../axios_config';

//查询收货列表基础数据
export const getTFSignForTaskcBySignForNumber = params => {
    return axios.get(`${BaseApiUrl}/TFSignFor/GetTFSignForTaskcBySignForNumber`, { params: params });
};
export const scanningTFSignForBox = params => {
    return axios.post(`${BaseApiUrl}/TFSignFor/ScanningTFSignForBox`, params);
};
export const insertTFInventoryInfo = params => {
    return axios.post(`${BaseApiUrl}/TFSignFor/InsertTFInventoryInfo`, params);
};
export const syncMachineData = params => {
    return axios.post(`${BaseApiUrl}/TFSignFor/SyncMachineData`, params);
};
export const deleteTFSignForBox = params => {
    return axios.get(`${BaseApiUrl}/TFSignFor/DeleteTFSignForBox`, { params: params });
};

//导入装箱数据
export const importTFSignForBox = `${BaseApiUrl}/TFSignFor/ImportTFSignForBox`;

//下载模板
export const downloadBatchBox = `${BaseUrl}/template/transfer/收货装箱模板.xlsx`;

//下载收货数据
export const exportDeliveryBoxInfoOut = `${BaseApiUrl}/TFSignFor/GetDeliveryBoxInfoOut`;

//下载机测数据
export const exportDeliveryBoxInfoMachine = `${BaseApiUrl}/TFSignFor/GetDeliveryBoxInfoMachine`;